// Suffix with Enum would be too much right ?
// Add the status code used in the application
export enum HttpStatusCode {
    ConnectionRefused = 0,
    OK = 200,
    Unauthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    NoContent = 204,
}